import type { ReactElement } from 'react';

import { ApiErrorMessage } from './ApiErrorMessage';

/**
 * The message of a failed request as toast content, for code that raises a toast outside a
 * component's render, or for a form to keep as its error. `fallback` is translated copy naming
 * what failed; `formatRefusal` wraps the server's reason for a refusal in a sentence.
 */
export function apiErrorContent(
    error: unknown,
    fallback?: string,
    formatRefusal?: (message: string) => string
): ReactElement {
    return <ApiErrorMessage error={error} fallback={fallback} formatRefusal={formatRefusal} />;
}
